#version 300 es
precision mediump float;
uniform vec4 uColor;
uniform vec3 uLightDir;
uniform vec3 uAmbient;
in vec3 vNormal;
out vec4 fragColor;
void main() {
  vec3 n = normalize(vNormal);
  float diff = max(dot(n, uLightDir), 0.0);
  vec3 lit = uAmbient + vec3(0.8) * diff;
  fragColor = vec4(uColor.rgb * lit, uColor.a);
}
